/**
 * Environment helper that works with both import.meta.env and process.env
 * This provides a fallback mechanism for accessing environment variables
 * across different module systems (ES modules vs CommonJS)
 */

interface EnvVars {
  MODE: string;
  VITE_MIXPANEL_DEBUG?: string;
}

function getEnvVar(key: string, fallback?: string): string | undefined {
  // Try import.meta.env first (for Vite/browser environments)
  try {
    if (typeof globalThis !== "undefined" && (globalThis as any).import?.meta?.env) {
      const value = (globalThis as any).import.meta.env[key];
      if (value !== undefined) return value;
    }
  } catch {
    // Ignore errors when import.meta is not available
  }

  // Fallback to process.env (for Node.js environments)
  if (typeof process !== "undefined" && process.env) {
    const value = process.env[key];
    if (value !== undefined) return value;
  }

  return fallback;
}

export const env: EnvVars = {
  get MODE() {
    return getEnvVar("MODE") || getEnvVar("NODE_ENV") || "development";
  },
  get VITE_MIXPANEL_DEBUG() {
    return getEnvVar("VITE_MIXPANEL_DEBUG");
  },
};
